module.exports = __webpack_public_path__ + "static/media/Mr.Tiny.048d7fa1.png";